import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "findErrorCode"
})

export class FindErrorCodesPipe implements PipeTransform {
  transform(errorCodes: Array<any>,elementName:string): any {
    return errorCodes.filter(x => x.propertyName && x.propertyName.toLowerCase()
     === elementName.toLowerCase() && x.messageType === 'ErrorMessage');
  }
}




// WEBPACK FOOTER //
// ./src/app/common/pipes/errorFind.pipe.ts